









import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import ganiAsiaTenantCodes from "@/constants/ganiAsiaTenantCodes";
import moment from "moment";

// Quantities may be fractional; round away floating point noise (4 decimals).
const roundQty = (n: number) => Math.round(n * 1e4) / 1e4;
import productComboProductItemRoles from "@/constants/productComboProductItemRoles";
import orderDataSources from "@/constants/orderDataSources";
import makeSelectOptions from "@common/util/makeSelectOptions";
import DataContainer from "@common/modules/vuetifyx/common/DataContainer";
import Bill from "./wholesale-orders/partials/Bill.vue";
import WholesaleBillImagesVue from "./wholesale-orders/partials/WholesaleBillImages.vue";

export default Vue.extend({
  data() {
    return {
      userManager,
      tableOptions: null,
      item: null,
    };
  },
  methods: {
    makeTableOptions(item) {
      const item2 = item;
      const baseCostField = ganiAsiaTenantCodes.includes(userManager.tenantCode()) ? "baseCost" : "estimatedBaseCost";

      return {
        attrs: {
          "item-key": "_id",
          "sort-by": "createdTime",
          "sort-desc": true,
        },
        content: {
          name: "Đơn đặt hàng sỉ",
          urlEnabled: true,
          search: {},
          filters: {
            filters: {
              code: {
                attrs: {
                  label: "Mã đơn hàng",
                },
                rules: {
                  match: {},
                },
              },
              dataSource: {
                type: "selectMultiple",
                attrs: {
                  label: "Nguồn data",
                  items: makeSelectOptions(orderDataSources),
                },
                rules: {
                  in: {},
                },
              },
              dataSourceId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Nguồn data (quản lý)",
                  "item-value": "_id",
                  "item-text": "name",
                  multiple: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("dataSources", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            filters: [
                              {
                                key: "_id",
                                operator: "in",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  in_id: {},
                },
              },
              customerId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Khách hàng",
                  required: true,
                  "item-value": "_id",
                  "item-text": "code",
                  "item-disabled": "_",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("wholesaleCustomers", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to: {},
                },
              },
              mktUserId: {
                type: "XAutocomplete",
                attrs: {
                  label: "User MKT",
                  required: true,
                  "item-value": "_id",
                  "item-text": "name",
                  "item-disabled": "_",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("users", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to: {},
                },
              },
              mktTeamId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Team",
                  required: true,
                  "item-value": "_id",
                  "item-text": "name",
                  "item-disabled": "_",
                  multiple: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("teams", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  in: {},
                },
              },
              mktDepartmentId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Phòng",
                  required: true,
                  "item-value": "_id",
                  "item-text": "name",
                  "item-disabled": "_",
                  multiple: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("departments", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  in: {},
                },
              },
              createdTime: {
                type: "XDateTimePicker",
                rules: {
                  greater_than_or_equal_to: {
                    attrs: {
                      label: "Ngày tạo (>=)",
                      xOptions: {
                        content: {
                          resultFilter: (m) => m.startOf("day"),
                        },
                      },
                    },
                  },
                  less_than_or_equal_to: {
                    attrs: {
                      label: "Ngày tạo (<=)",
                      xOptions: {
                        content: {
                          resultFilter: (m) => m.endOf("day"),
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          displayFields: {
            code: {
              text: "Mã đơn hàng",
            },
            dataSource: {
              text: "Nguồn data",
              options: {
                label(value) {
                  return orderDataSources[value || ""];
                },
              },
            },
            dataSourceRef: {
              text: "Nguồn data (quản lý)",
              options: {
                subProp: "dataSourceRef.name",
                sortBy: "dataSourceId",
              },
            },
            customer: {
              text: "Khách hàng",
              options: {
                subProp: "customer.code",
              },
            },
            time: {
              text: "Order Date",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            paid: {
              text: "Đã thanh toán",
              options: {
                boolean: true,
              },
            },
            products: {
              text: "Sản phẩm",
              options: {
                labels(_, item) {
                  return [""].concat(item.items?.map((pi) => pi.product?.sku || "N/A"));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            productGroups: {
              text: "Nhóm sản phẩm",
              options: {
                labels(_, item) {
                  return [""].concat(item.items?.map((pi) => pi.product?.productGroup.sku || "N/A"));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            types: {
              text: "Loại sản phẩm",
              options: {
                labels(_, item) {
                  return [""].concat(item.items?.map((pi) => productComboProductItemRoles[pi.type] || "N/A"));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            counts: {
              text: "Số lượng",
              options: {
                labels(_, item) {
                  return [""].concat(item.items?.map((pi) => pi.count));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            prices: {
              text: "Đơn giá trước discount",
              options: {
                labels(_, item) {
                  return [""].concat(item.items?.map((pi) => Vue.filter("currency")((pi.price || 0))));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            discount: {
              text: "Discount",
              options: {
                labels(_, item) {
                  return [""].concat(item.items?.map((pi) => `${pi.discountPercentage}%`));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            pricesAfterDiscount: {
              text: "Đơn giá sau discount",
              options: {
                labels(_, item) {
                  return [""].concat(item.items?.map((pi) => Vue.filter("currency")((pi.price || 0) * (1 - (pi.discountPercentage || 0) / 100))));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            totalPrices: {
              text: "Tổng giá trước discount",
              options: {
                labels(_, item) {
                  return [
                    {
                      value: Vue.filter("currency")(item.items.reduce((total, pi) => total + (pi.price || 0) * pi.count, 0)),
                      attrs: {
                        outlined: true,
                      },
                    },
                  ].concat(item.items?.map((pi) => Vue.filter("currency")((pi.price || 0) * pi.count)));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            totalPricesAfterDiscount: {
              text: "Tổng giá sau discount",
              options: {
                labels(_, item) {
                  return [
                    {
                      value: Vue.filter("currency")(item.items.reduce((total, pi) => total + (pi.price || 0) * (1 - (pi.discountPercentage || 0) / 100) * pi.count, 0)),
                      attrs: {
                        outlined: true,
                      },
                    },
                  ].concat(item.items?.map((pi) => Vue.filter("currency")((pi.price || 0) * (1 - pi.discountPercentage / 100) * pi.count)));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            shippingFee: {
              text: "Phí Ship",
              options: {
                filter: "currency",
              },
            },
            sampleFee: {
              text: "Phí sample",
              options: {
                filter: "currency",
              },
            },
            shippingPaid: {
              text: "Đã TT phí ship",
              options: {
                boolean: true,
              },
            },
            samplePaid: {
              text: "Đã TT phí sample",
              options: {
                boolean: true,
              },
            },
            realTotalPrice: {
              text: "Số tiền thực nhận",
              options: {
                labels(_, item) {
                  return [
                    {
                      value: Vue.filter("currency")(item.items.reduce((total, pi) => total + pi.realTotalPrice, 0)),
                      attrs: {
                        outlined: true,
                      },
                    },
                  ].concat(item.items?.map((pi) => Vue.filter("currency")(pi.realTotalPrice)));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            cashback: {
              text: "Cashback",
              options: {
                filter: "currency",
              },
            },
            totalPricesAfterCashback: {
              text: "Tổng giá sau cashback",
              options: {
                preTransform(_, item) {
                  return item.items.reduce((total, pi) => total + (pi.price || 0) * (1 - (pi.discountPercentage || 0) / 100) * pi.count, 0) - (item.cashback || 0);
                },
                filter: "currency",
              },
            },
            revenue: {
              text: "Doanh số",
              options: {
                filter: "currency",
                preTransform(_, item) {
                  return item.items.reduce((total, pi) => total + (pi.price || 0) * (1 - (pi.discountPercentage || 0) / 100) * pi.count, 0) * (item.exchangeRate ?? item.market?.country?.exchangeRate);
                },
              },
            },
            estimatedBaseCost: {
              text: "Giá vốn",
              options: {
                filter: "currency",
                preTransform(_, item) {
                  return item.items.reduce((total, pi) => total + (pi[baseCostField] ?? pi.product?.[baseCostField] ?? 0) * pi.count, 0);
                },
              },
            },
            profit: {
              text: "Lợi nhuận (chưa trừ chi phí kinh doanh)",
              options: {
                filter: "currency",
                preTransform(_, item) {
                  return (
                    item.items.reduce((total, pi) => total + (pi.price || 0) * (1 - (pi.discountPercentage || 0) / 100) * pi.count, 0) * (item.exchangeRate ?? item.market?.country?.exchangeRate) -
                    item.items.reduce((total, pi) => total + (pi[baseCostField] ?? pi.product?.[baseCostField] ?? 0) * pi.count, 0)
                  );
                },
              },
            },
            profitPercentage: {
              text: "% Lợi nhuận (chưa trừ chi phí kinh doanh) / doanh số",
              options: {
                preTransform(_, item) {
                  const cost = item.items.reduce((total, pi) => total + (pi[baseCostField] ?? pi.product?.[baseCostField] ?? 0) * pi.count, 0);
                  const revenue = item.items.reduce((total, pi) => total + (pi.price || 0) * (1 - (pi.discountPercentage || 0) / 100) * pi.count, 0) * (item.exchangeRate ?? item.market?.country?.exchangeRate);
                  let value = (revenue - cost) / revenue;
                  value = Math.round(value * 10000) / 100;
                  return value + "%";
                },
              },
            },
            mktUser: {
              text: "User MKT",
              options: {
                subProp: "mktUser.name",
                sortBy: "mktUserId",
                attrs(_, item) {
                  const attrs: any = {};
                  if (item.mktUser && item.mktUser.ht === "nv") {
                    attrs.class = "red--text";
                  }
                  return attrs;
                },
              },
            },
            mktTeam: {
              text: "Team",
              options: {
                subProp: "mktTeam.name",
                sortBy: "mktTeamId",
              },
            },
            mktDepartment: {
              text: "Phòng",
              options: {
                subProp: "mktDepartment.name",
                sortBy: "mktDepartmentId",
              },
            },
            mktPlatform: {
              text: "Nền tảng MKT",
              options: {
                subProp: "mktPlatform.name",
                sortBy: "mktPlatformId",
              },
            },
            warehouse: {
              text: "Kho",
              options: {
                subProp: "warehouse.name",
              },
            },
            customerCode: {
              text: "Mã KH",
              options: {
                subProp: "customer.code",
              },
            },
            customerName: {
              text: "Tên",
              options: {
                subProp: "customer.name",
              },
            },
            customerPhone: {
              text: "SĐT",
              options: {
                subProp: "customer.phoneNumber",
              },
            },
            customerAddress: {
              text: "Địa chỉ",
              options: {
                subProp: "customer.address",
              },
            },
            paymentPartner: {
              text: "Đối tac thanh toán",
              options: {
                label: (value) => value.name,
              },
            },
            paymentAccount: {
              text: "Tài khoản thanh toán",
              options: {
                label: (value) => value.name,
              },
            },
            exportDate: {
              text: "Ngày xuất kho",
              options: {
                labels(_, item) {
                  return [""].concat((item.paymentRecords || []).map((r) => (r.exportDate ? moment(r.exportDate).format("DD/MM/YYYY") : "")));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            exportTurn: {
              text: "Lần xuất kho",
              options: {
                labels(_, item) {
                  return [""].concat((item.paymentRecords || []).map((r) => r.turn));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            exportedQuantity: {
              text: "Số lượng thực tế xuất kho",
              options: {
                labels(_, item) {
                  return [""].concat((item.paymentRecords || []).map((r) => (r.items || []).reduce((s, i) => s + i.count, 0)));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            paymentTurn: {
              text: "Lần thanh toán",
              options: {
                labels(_, item) {
                  return [""].concat((item.paymentRecords || []).map((r) => r.turn));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            paymentReceivedAmount: {
              text: "Số tiền thực nhận (peso)",
              options: {
                labels(_, item) {
                  return [""].concat((item.paymentRecords || []).map((r) => Vue.filter("currency")(r.receivedAmount)));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            paymentRemainingAmount: {
              text: "Số tiền còn phải thu (peso)",
              options: {
                labels(_, item) {
                  const totalDue = item.items.reduce((s, pi) => s + (pi.price || 0) * (1 - (pi.discountPercentage || 0) / 100) * pi.count, 0) - (item.cashback || 0);
                  let cum = 0;
                  return [""].concat(
                    (item.paymentRecords || []).map((r) => {
                      cum += r.receivedAmount || 0;
                      return Vue.filter("currency")(totalDue - cum);
                    })
                  );
                },
                labelsSeparatedByNewLine: true,
              },
            },
            paymentPaid: {
              text: "Đã Thanh toán",
              options: {
                labels(_, item) {
                  return [""].concat((item.paymentRecords || []).map((r) => (r.paid ? "TRUE" : "FALSE")));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            paymentRecordPartnerName: {
              text: "Đối tác thanh toán",
              options: {
                labels(_, item) {
                  return [""].concat((item.paymentRecords || []).map((r) => r.paymentPartner?.name || r.paymentPartnerName || ""));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            paymentRecordAccountName: {
              text: "Tài khoản thanh toán (lần)",
              options: {
                labels(_, item) {
                  return [""].concat(
                    (item.paymentRecords || []).map((r) => {
                      const acc = r.paymentAccount;
                      return acc ? `${acc.name} - ${acc.cardNumber} - ${acc.bankName}` : r.paymentAccountName || "";
                    })
                  );
                },
                labelsSeparatedByNewLine: true,
              },
            },
            shippingPaymentTurn: {
              text: "Lần TT phí ship",
              options: {
                labels(_, item) {
                  return [""].concat((item.shippingPaymentRecords || []).map((r) => r.turn));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            shippingPaymentReceivedAmount: {
              text: "Số tiền đã nhận (phí ship)",
              options: {
                labels(_, item) {
                  return [""].concat((item.shippingPaymentRecords || []).map((r) => Vue.filter("currency")(r.receivedAmount)));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            shippingPaymentRecordPartnerName: {
              text: "Đối tác TT (phí ship)",
              options: {
                labels(_, item) {
                  return [""].concat((item.shippingPaymentRecords || []).map((r) => r.paymentPartner?.name || r.paymentPartnerName || ""));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            shippingPaymentRecordAccountName: {
              text: "TK TT (phí ship)",
              options: {
                labels(_, item) {
                  return [""].concat(
                    (item.shippingPaymentRecords || []).map((r) => {
                      const acc = r.paymentAccount;
                      return acc ? `${acc.name} - ${acc.cardNumber} - ${acc.bankName}` : r.paymentAccountName || "";
                    })
                  );
                },
                labelsSeparatedByNewLine: true,
              },
            },
            samplePaymentTurn: {
              text: "Lần TT phí sample",
              options: {
                labels(_, item) {
                  return [""].concat((item.samplePaymentRecords || []).map((r) => r.turn));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            samplePaymentReceivedAmount: {
              text: "Số tiền đã nhận (phí sample)",
              options: {
                labels(_, item) {
                  return [""].concat((item.samplePaymentRecords || []).map((r) => Vue.filter("currency")(r.receivedAmount)));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            samplePaymentRecordPartnerName: {
              text: "Đối tác TT (phí sample)",
              options: {
                labels(_, item) {
                  return [""].concat((item.samplePaymentRecords || []).map((r) => r.paymentPartner?.name || r.paymentPartnerName || ""));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            samplePaymentRecordAccountName: {
              text: "TK TT (phí sample)",
              options: {
                labels(_, item) {
                  return [""].concat(
                    (item.samplePaymentRecords || []).map((r) => {
                      const acc = r.paymentAccount;
                      return acc ? `${acc.name} - ${acc.cardNumber} - ${acc.bankName}` : r.paymentAccountName || "";
                    })
                  );
                },
                labelsSeparatedByNewLine: true,
              },
            },
            maxExportableQtyPerTurn: {
              text: "Số lượng tối đa có thể xuất kho theo số tiền thực nhận (pcs)",
              options: {
                labels(_, item) {
                  const mainItems = (item.items || []).filter((i) => i.type === "main");
                  const paymentRecords = item.paymentRecords || [];
                  return [""].concat(
                    paymentRecords.map((r, idx) => {
                      const prevRecords = paymentRecords.slice(0, idx);
                      let total = 0;
                      for (const mainItem of mainItems) {
                        const unitPrice = (mainItem.price || 0) * (1 - (mainItem.discountPercentage || 0) / 100);
                        if (unitPrice <= 0) {
                          continue;
                        }
                        const alreadyReceived = prevRecords.reduce((s, pr) => {
                          const ri = (pr.items || []).find((i) => i.productId === mainItem.productId);
                          return s + (ri?.realTotalPrice || 0);
                        }, 0);
                        const currentReceived = (r.items || []).find((i) => i.productId === mainItem.productId)?.realTotalPrice || 0;
                        const alreadyExported = prevRecords.reduce((s, pr) => {
                          const ri = (pr.items || []).find((i) => i.productId === mainItem.productId);
                          return s + (ri?.count || 0);
                        }, 0);
                        total += Math.min(roundQty((alreadyReceived + currentReceived) / unitPrice - alreadyExported), roundQty(mainItem.count - alreadyExported));
                      }
                      return total;
                    })
                  );
                },
                labelsSeparatedByNewLine: true,
              },
            },
            totalRemainingQty: {
              text: "Số lượng còn phải xuất (pcs)",
              options: {
                labels(_, item) {
                  const mainItems = (item.items || []).filter((i) => i.type === "main");
                  const paymentRecords = item.paymentRecords || [];
                  return [""].concat(
                    paymentRecords.map((r, idx) => {
                      const prevRecords = paymentRecords.slice(0, idx);
                      let total = 0;
                      for (const mainItem of mainItems) {
                        const unitPrice = (mainItem.price || 0) * (1 - (mainItem.discountPercentage || 0) / 100);
                        if (unitPrice <= 0) {
                          continue;
                        }
                        const alreadyReceived = prevRecords.reduce((s, pr) => {
                          const ri = (pr.items || []).find((i) => i.productId === mainItem.productId);
                          return s + (ri?.realTotalPrice || 0);
                        }, 0);
                        const currentReceived = (r.items || []).find((i) => i.productId === mainItem.productId)?.realTotalPrice || 0;
                        const alreadyExported = prevRecords.reduce((s, pr) => {
                          const ri = (pr.items || []).find((i) => i.productId === mainItem.productId);
                          return s + (ri?.count || 0);
                        }, 0);
                        total += Math.min(roundQty((alreadyReceived + currentReceived) / unitPrice - alreadyExported - r.items.filter((i) => i.productId === mainItem.productId).reduce((s, i) => s + i.count, 0)), roundQty(mainItem.count - alreadyExported));
                      }
                      return total;
                    })
                  );
                },
                labelsSeparatedByNewLine: true,
              },
            },
            wholesaleConfirmed: {
              text: "KT xác nhận",
              options: {
                boolean: true,
              },
            },
            wholesaleExchangeRate: {
              text: "Tỷ giá KT",
            },
            action: {},
          },
          topActionButtons: {
            insert: userManager.checkRole(["admin", "kt", "vd", "vdl"]) && {
              target: {
                dialog: {
                  attrs: {
                    width: "80%",
                  },
                },
              },
            },
          },
          template: {
            itemActionButtons: {
              edit: userManager.checkRole(["admin", "kt", "vd", "vdl"]) && {
                target: {
                  dialog: {
                    attrs: {
                      width: "80%",
                    },
                    ext: {
                      subTitleMaker({ startDate, endDate }) {
                        return `${moment(startDate).format("YYYY-MM-DD")} - ${moment(endDate).format("YYYY-MM-DD")}`;
                      },
                    },
                  },
                },
              },
              delete: userManager.checkRole(["admin"]) && {},
              pricing: {
                attrs: {},
                content: {
                  icon: "mdi-cash-multiple",
                },
                target: {
                  tooltip: {
                    content: {
                      text: "BILL RECEIPT",
                    },
                  },
                  dialog: {
                    attrs: {
                      width: "80%",
                    },
                    content: {
                      toolbar: {
                        title: "BILL RECEIPT",
                        subTitle(dialog) {
                          const btn = dialog.context();
                          const { item } = btn.context();
                          return item.code;
                        },
                      },
                      content: {
                        type: Bill,
                        makeAttrs(attrs, dialog) {
                          const { item } = dialog.context().context();
                          attrs.item = item;
                          return attrs;
                        },
                        attrs: {},
                      },
                    },
                  },
                },
              },
              approvePayment: userManager.checkRole(["kt"]) && {
                ext: {
                  condition(_, item) {
                    const alreadyExported = (item.paymentRecords || []).reduce((s, r) => {
                      return s + (r.items || []).reduce((si, ri) => si + ri.count, 0);
                    }, 0);
                    const total = (item.items || []).reduce((s, pi) => s + pi.count, 0);
                    return alreadyExported < total;
                  },
                },
                attrs: {},
                content: {
                  icon: "mdi-check-decagram",
                },
                target: {
                  tooltip: {
                    content: {
                      text: "Xác nhận thanh toán tiền hàng",
                    },
                  },
                  dialog: {
                    handlers: {
                      initialize() {
                        this.options.content.buttons.save.states.enabled = new DataContainer(false);
                      },
                    },
                    attrs: {
                      width: "80%",
                    },
                    content: {
                      toolbar: {
                        title: "Xác nhận thanh toán tiền hàng",
                        subTitle(dialog) {
                          const btn = dialog.context();
                          const { item } = btn.context();
                          return item.code;
                        },
                      },
                      content: {
                        type: "XForm",
                        makeAttrs(attrs, dialog) {
                          const { item } = dialog.context().context();
                          attrs.xModel = dialog.options.content.buttons.save.states.enabled;
                          attrs.xContext = dialog;

                          // Compute already-exported and already-received quantities per product from payment history.
                          // Legacy orders (paid=true, no paymentRecords) are treated as fully delivered.
                          const hasPaymentRecords = item.paymentRecords && item.paymentRecords.length > 0;
                          const isLegacyPaid = item.paid && !hasPaymentRecords;

                          // Orders can contain two or more line items for the same product (e.g.
                          // duplicated gift rows). productId alone can't disambiguate those, so for
                          // such products key history by item position (itemIndex) instead. Products
                          // that appear only once keep plain productId keying so existing payment
                          // records (which predate itemIndex) keep matching correctly.
                          const productIdCounts: Record<string, number> = {};
                          (item.items || []).forEach((pi) => {
                            productIdCounts[pi.productId] = (productIdCounts[pi.productId] || 0) + 1;
                          });
                          const isAmbiguousProduct = (productId: string) => (productIdCounts[productId] || 0) > 1;
                          const itemKey = (productId: string, itemIndex?: number) =>
                            isAmbiguousProduct(productId) && itemIndex != null ? `${productId}#${itemIndex}` : productId;

                          const alreadyExportedByKey: Record<string, number> = {};
                          const alreadyReceivedByKey: Record<string, number> = {};
                          if (!isLegacyPaid) {
                            for (const record of item.paymentRecords || []) {
                              for (const ri of record.items || []) {
                                const key = itemKey(ri.productId, ri.itemIndex);
                                alreadyExportedByKey[key] = (alreadyExportedByKey[key] || 0) + ri.count;
                                alreadyReceivedByKey[key] = (alreadyReceivedByKey[key] || 0) + (ri.realTotalPrice || 0);
                              }
                            }
                          }

                          item.items?.forEach((pi, index) => {
                            const key = itemKey(pi.productId, index);
                            pi.totalPriceAfterDiscount = (pi.price || 0) * (1 - (pi.discountPercentage || 0) / 100) * pi.count;
                            pi.alreadyExportedCount = isLegacyPaid ? pi.count : alreadyExportedByKey[key] || 0;
                            pi.remainingCount = pi.count - pi.alreadyExportedCount;
                            pi.totalAlreadyReceived = isLegacyPaid ? pi.totalPriceAfterDiscount : alreadyReceivedByKey[key] || 0;
                            pi.remainingRealTotalPrice = Math.max(0, pi.totalPriceAfterDiscount - pi.totalAlreadyReceived);
                            const pricePerUnit = (pi.price || 0) * (1 - (pi.discountPercentage || 0) / 100);
                            const maxByPayment = pricePerUnit > 0 ? roundQty((pi.totalAlreadyReceived + pi.remainingRealTotalPrice) / pricePerUnit - pi.alreadyExportedCount) : pi.remainingCount;
                            pi.maxExportableByPayment = Math.min(Math.max(0, maxByPayment), pi.remainingCount);
                          });

                          attrs.xData = new DataContainer({
                            paymentPartnerId: item.paymentPartnerId,
                            paymentAccountId: item.paymentAccountId,
                            items: item.items.map((pi) => ({
                              ...pi,
                              count: pi.remainingCount,
                              realTotalPrice: pi.remainingRealTotalPrice,
                            })),
                          });
                          attrs.xOptions = {
                            content: {
                              sections: {
                                default: {
                                  fields: {
                                    paymentPartnerId: {
                                      type: "XAutocomplete",
                                      attrs: {
                                        label: "Đối tác",
                                        required: true,
                                        "item-value": "_id",
                                        "item-text": "name",
                                        xOptions: {
                                          content: {
                                            async itemsSuggestor(search, value, limit) {
                                              const { items } = await coreApiClient.call("paymentPartners", "findAll", {
                                                payload: JSON.stringify({
                                                  limit,
                                                  search,
                                                  filters: [
                                                    {
                                                      key: "_id",
                                                      operator: "equal_to",
                                                      value,
                                                    },
                                                  ],
                                                }),
                                              });
                                              return items;
                                            },
                                          },
                                        },
                                      },
                                    },
                                    paymentAccountId: {
                                      type: "XAutocomplete",
                                      attrs: {
                                        label: "TKNH",
                                        required: true,
                                        "item-value": "_id",
                                        "item-text": "name",
                                        xOptions: {
                                          content: {
                                            async itemsSuggestor(search, value, limit) {
                                              const { items } = await coreApiClient.call("paymentAccounts", "findAll", {
                                                payload: JSON.stringify({
                                                  limit,
                                                  search,
                                                  filters: [
                                                    {
                                                      key: "_id",
                                                      operator: "equal_to",
                                                      value,
                                                    },
                                                  ],
                                                }),
                                              });
                                              items.forEach((item) => {
                                                item.name = `${item.name} - ${item.cardNumber} - ${item.bankName}`;
                                              });
                                              return items;
                                            },
                                          },
                                        },
                                      },
                                    },
                                    items: {
                                      type: "XArrayInput",
                                      attrs: {
                                        label: "",
                                        xOptions: {
                                          content: {
                                            deleteDisabled: true,
                                            addItemBtn: {
                                              ext: {
                                                hidden: true,
                                              },
                                            },
                                            template: {
                                              formOptions: {
                                                content: {
                                                  colLength: 4,
                                                  rules: {
                                                    countMax(data) {
                                                      const pricePerUnit = (data.price || 0) * (1 - (data.discountPercentage || 0) / 100);
                                                      const totalAlreadyReceived = data.totalAlreadyReceived || 0;
                                                      const alreadyExportedCount = data.alreadyExportedCount || 0;
                                                      const maxByPayment = pricePerUnit > 0 ? roundQty((totalAlreadyReceived + (data.realTotalPrice || 0)) / pricePerUnit - alreadyExportedCount) : data.remainingCount ?? Infinity;
                                                      const maxAllowed = Math.min(Math.max(0, maxByPayment), data.remainingCount ?? Infinity);
                                                      if ((data.count || 0) > maxAllowed) {
                                                        return false;
                                                      }
                                                      return true;
                                                    },
                                                  },
                                                },
                                              },
                                            },
                                            itemProperties: {
                                              productId: {
                                                type: "XAutocomplete",
                                                attrs: {
                                                  label: "Sản phẩm",
                                                  "item-value": "_id",
                                                  "item-text": "sku",
                                                  "item-disabled": "_",
                                                  required: true,
                                                  readonly: true,
                                                  xOptions: {
                                                    content: {
                                                      async itemsSuggestor(search, value, limit) {
                                                        const { items } = await coreApiClient.call("products", "findAll", {
                                                          payload: JSON.stringify({
                                                            limit,
                                                            search,
                                                            filters: [
                                                              {
                                                                key: "_id",
                                                                operator: "equal_to",
                                                                value,
                                                              },
                                                              {
                                                                key: "countryId",
                                                                operator: "equal_to",
                                                                value: item.countryId,
                                                              },
                                                            ],
                                                          }),
                                                        });
                                                        return items;
                                                      },
                                                    },
                                                  },
                                                },
                                              },
                                              type: {
                                                type: "select",
                                                attrs: {
                                                  text: "Loại sản phẩm",
                                                  items: makeSelectOptions(productComboProductItemRoles),
                                                  required: true,
                                                  readonly: true,
                                                },
                                              },
                                              alreadyExportedCount: {
                                                type: "number",
                                                attrs: {
                                                  label: "Đã xuất kho",
                                                  readonly: true,
                                                },
                                              },
                                              remainingCount: {
                                                type: "number",
                                                attrs: {
                                                  label: "Tổng số lượng còn có thể xuất kho (pcs)",
                                                  readonly: true,
                                                },
                                              },
                                              maxExportableByPayment: {
                                                type: "number",
                                                attrs: {
                                                  label: "Số lượng tối đa có thể xuất kho theo số tiền thực nhận (pcs)",
                                                  readonly: true,
                                                },
                                              },
                                              totalAlreadyReceived: {
                                                type: "number",
                                                attrs: {
                                                  label: "Đã nhận (tiền)",
                                                  readonly: true,
                                                },
                                              },
                                              count: {
                                                type: ganiAsiaTenantCodes.includes(userManager.tenantCode()) ? "number" : "number", // float for all tenants
                                                attrs: {
                                                  label: "Số lượng (lần này)",
                                                  required: true,
                                                },
                                                content: {
                                                  allowZero: true,
                                                },
                                              },
                                              price: {
                                                type: "number",
                                                attrs: {
                                                  label: "Đơn giá",
                                                  readonly: true,
                                                },
                                              },
                                              discountPercentage: {
                                                type: "number",
                                                attrs: {
                                                  label: "Discount (%)",
                                                  readonly: true,
                                                },
                                              },
                                              totalPriceAfterDiscount: {
                                                type: "number",
                                                attrs: {
                                                  label: "Tổng giá sau discount",
                                                  readonly: true,
                                                },
                                              },
                                              realTotalPrice: {
                                                type: "number",
                                                ext: {
                                                  onInput(realTotalPrice, form) {
                                                    const d = form.getData();
                                                    const pricePerUnit = (d.price || 0) * (1 - (d.discountPercentage || 0) / 100);
                                                    const remainingCount = d.remainingCount ?? 0;
                                                    const maxByPayment = pricePerUnit > 0 ? roundQty(((d.totalAlreadyReceived || 0) + (realTotalPrice || 0)) / pricePerUnit - (d.alreadyExportedCount || 0)) : remainingCount;
                                                    const maxExportable = form.inputs.maxExportableByPayment;
                                                    if (maxExportable) {
                                                      maxExportable.value = Math.min(Math.max(0, maxByPayment), remainingCount);
                                                    }
                                                  },
                                                },
                                                attrs: {
                                                  label: "Số tiền thực nhận (lần này)",
                                                },
                                              },
                                            },
                                          },
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                            },
                          };
                          return attrs;
                        },
                        attrs: {},
                      },
                      buttons: {
                        save: {
                          content: {
                            text: "Xác nhận thanh toán tiền hàng",
                          },
                          states: {},
                          on: {
                            async xClick({ self }) {
                              const dialog = self.context();
                              const btn = dialog.context();
                              const { item, dataTable } = btn.context();
                              const form = dialog.contentContainer.value;
                              const data = form.getData();
                              const hasNonZeroItem = (data.items || []).some((pi) => (pi.count || 0) > 0);
                              if (!hasNonZeroItem) {
                                alert("Vui lòng nhập số lượng sản phẩm trước khi xác nhận.");
                                return;
                              }
                              self.loading.value = true;
                              const result = await dataTable.execute(
                                async () => {
                                  return await coreApiClient.call(
                                    "wholesaleOrders",
                                    "confirmPayment",
                                    {
                                      id: item._id,
                                    },
                                    {
                                      paymentPartnerId: data.paymentPartnerId,
                                      paymentAccountId: data.paymentAccountId,
                                      paymentItems: item.items.map((pi, index) => ({
                                        productId: pi.productId,
                                        itemIndex: index,
                                        count: data.items[index].count,
                                        realTotalPrice: data.items[index].realTotalPrice,
                                      })),
                                    }
                                  );
                                },
                                undefined,
                                {
                                  disableLoading: true,
                                  willRefresh: true,
                                }
                              );
                              self.loading.value = false;
                              if (result) {
                                dialog.hide();
                              }
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
              confirmShippingPayment: userManager.checkRole(["kt"]) && {
                ext: {
                  condition(_, item) {
                    return !!item.shippingFee && !item.shippingPaid;
                  },
                },
                attrs: {},
                content: {
                  icon: "mdi-truck-delivery",
                },
                target: {
                  tooltip: {
                    content: {
                      text: "Xác nhận thanh toán phí ship",
                    },
                  },
                  dialog: {
                    handlers: {
                      initialize() {
                        this.options.content.buttons.save.states.enabled = new DataContainer(false);
                      },
                    },
                    content: {
                      toolbar: {
                        title: "Xác nhận thanh toán phí ship",
                        subTitle(dialog) {
                          const btn = dialog.context();
                          const { item } = btn.context();
                          return item.code;
                        },
                      },
                      content: {
                        type: "XForm",
                        makeAttrs(attrs, dialog) {
                          const { item } = dialog.context().context();
                          attrs.xModel = dialog.options.content.buttons.save.states.enabled;
                          attrs.xContext = dialog;
                          const alreadyReceived = (item.shippingPaymentRecords || []).reduce((s, r) => s + (r.receivedAmount || 0), 0);
                          attrs.xData = new DataContainer({
                            shippingFee: item.shippingFee,
                            alreadyReceived,
                            remaining: (item.shippingFee || 0) - alreadyReceived,
                          });
                          attrs.xOptions = {
                            content: {
                              sections: {
                                default: {
                                  fields: {
                                    shippingFee: {
                                      type: "number",
                                      attrs: {
                                        label: "Phí Ship",
                                        readonly: true,
                                      },
                                    },
                                    alreadyReceived: {
                                      type: "number",
                                      attrs: {
                                        label: "Đã nhận",
                                        readonly: true,
                                      },
                                    },
                                    remaining: {
                                      type: "number",
                                      attrs: {
                                        label: "Còn lại",
                                        readonly: true,
                                      },
                                    },
                                    paymentPartnerId: {
                                      type: "XAutocomplete",
                                      attrs: {
                                        label: "Đối tác",
                                        required: true,
                                        "item-value": "_id",
                                        "item-text": "name",
                                        xOptions: {
                                          content: {
                                            async itemsSuggestor(search, value, limit) {
                                              const { items } = await coreApiClient.call("paymentPartners", "findAll", {
                                                payload: JSON.stringify({
                                                  limit,
                                                  search,
                                                  filters: [
                                                    {
                                                      key: "_id",
                                                      operator: "equal_to",
                                                      value,
                                                    },
                                                  ],
                                                }),
                                              });
                                              return items;
                                            },
                                          },
                                        },
                                      },
                                    },
                                    paymentAccountId: {
                                      type: "XAutocomplete",
                                      attrs: {
                                        label: "TKNH",
                                        required: true,
                                        "item-value": "_id",
                                        "item-text": "name",
                                        xOptions: {
                                          content: {
                                            async itemsSuggestor(search, value, limit) {
                                              const { items } = await coreApiClient.call("paymentAccounts", "findAll", {
                                                payload: JSON.stringify({
                                                  limit,
                                                  search,
                                                  filters: [
                                                    {
                                                      key: "_id",
                                                      operator: "equal_to",
                                                      value,
                                                    },
                                                  ],
                                                }),
                                              });
                                              items.forEach((item) => {
                                                item.name = `${item.name} - ${item.cardNumber} - ${item.bankName}`;
                                              });
                                              return items;
                                            },
                                          },
                                        },
                                      },
                                    },
                                    receivedAmount: {
                                      type: "number",
                                      attrs: {
                                        label: "Số tiền thực nhận",
                                        required: true,
                                      },
                                    },
                                  },
                                },
                              },
                            },
                          };
                          return attrs;
                        },
                        attrs: {},
                      },
                      buttons: {
                        save: {
                          content: {
                            text: "Xác nhận",
                          },
                          states: {},
                          on: {
                            async xClick({ self }) {
                              const dialog = self.context();
                              const btn = dialog.context();
                              const { item, dataTable } = btn.context();
                              const form = dialog.contentContainer.value;
                              const data = form.getData();
                              if (!data.receivedAmount) {
                                alert("Vui lòng nhập số tiền thực nhận.");
                                return;
                              }
                              const alreadyReceivedAmount = (item.shippingPaymentRecords || []).reduce((s, r) => s + (r.receivedAmount || 0), 0);
                              if (alreadyReceivedAmount + data.receivedAmount > (item.shippingFee || 0)) {
                                alert("Số tiền đã nhận không được lớn hơn phí ship.");
                                return;
                              }
                              self.loading.value = true;
                              const result = await dataTable.execute(
                                async () => {
                                  return await coreApiClient.call(
                                    "wholesaleOrders",
                                    "confirmShippingPayment",
                                    {
                                      id: item._id,
                                    },
                                    {
                                      paymentPartnerId: data.paymentPartnerId,
                                      paymentAccountId: data.paymentAccountId,
                                      receivedAmount: data.receivedAmount,
                                    }
                                  );
                                },
                                undefined,
                                {
                                  disableLoading: true,
                                  willRefresh: true,
                                }
                              );
                              self.loading.value = false;
                              if (result) {
                                dialog.hide();
                              }
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
              confirmSamplePayment: userManager.checkRole(["kt"]) && {
                ext: {
                  condition(_, item) {
                    return !!item.sampleFee;
                  },
                },
                attrs: {},
                content: {
                  icon: "mdi-flask-outline",
                },
                target: {
                  tooltip: {
                    content: {
                      text: "Xác nhận thanh toán phí sample",
                    },
                  },
                  dialog: {
                    handlers: {
                      initialize() {
                        this.options.content.buttons.save.states.enabled = new DataContainer(false);
                      },
                    },
                    content: {
                      toolbar: {
                        title: "Xác nhận thanh toán phí sample",
                        subTitle(dialog) {
                          const btn = dialog.context();
                          const { item } = btn.context();
                          return item.code;
                        },
                      },
                      content: {
                        type: "XForm",
                        makeAttrs(attrs, dialog) {
                          const { item } = dialog.context().context();
                          attrs.xModel = dialog.options.content.buttons.save.states.enabled;
                          attrs.xContext = dialog;
                          const alreadyReceived = (item.samplePaymentRecords || []).reduce((s, r) => s + (r.receivedAmount || 0), 0);
                          attrs.xData = new DataContainer({
                            sampleFee: item.sampleFee,
                            alreadyReceived,
                            remaining: (item.sampleFee || 0) - alreadyReceived,
                          });
                          attrs.xOptions = {
                            content: {
                              sections: {
                                default: {
                                  fields: {
                                    sampleFee: {
                                      type: "number",
                                      attrs: {
                                        label: "Phí sample",
                                        readonly: true,
                                      },
                                    },
                                    alreadyReceived: {
                                      type: "number",
                                      attrs: {
                                        label: "Đã nhận",
                                        readonly: true,
                                      },
                                    },
                                    remaining: {
                                      type: "number",
                                      attrs: {
                                        label: "Còn lại",
                                        readonly: true,
                                      },
                                    },
                                    paymentPartnerId: {
                                      type: "XAutocomplete",
                                      attrs: {
                                        label: "Đối tác",
                                        required: true,
                                        "item-value": "_id",
                                        "item-text": "name",
                                        xOptions: {
                                          content: {
                                            async itemsSuggestor(search, value, limit) {
                                              const { items } = await coreApiClient.call("paymentPartners", "findAll", {
                                                payload: JSON.stringify({
                                                  limit,
                                                  search,
                                                  filters: [
                                                    {
                                                      key: "_id",
                                                      operator: "equal_to",
                                                      value,
                                                    },
                                                  ],
                                                }),
                                              });
                                              return items;
                                            },
                                          },
                                        },
                                      },
                                    },
                                    paymentAccountId: {
                                      type: "XAutocomplete",
                                      attrs: {
                                        label: "TKNH",
                                        required: true,
                                        "item-value": "_id",
                                        "item-text": "name",
                                        xOptions: {
                                          content: {
                                            async itemsSuggestor(search, value, limit) {
                                              const { items } = await coreApiClient.call("paymentAccounts", "findAll", {
                                                payload: JSON.stringify({
                                                  limit,
                                                  search,
                                                  filters: [
                                                    {
                                                      key: "_id",
                                                      operator: "equal_to",
                                                      value,
                                                    },
                                                  ],
                                                }),
                                              });
                                              items.forEach((item) => {
                                                item.name = `${item.name} - ${item.cardNumber} - ${item.bankName}`;
                                              });
                                              return items;
                                            },
                                          },
                                        },
                                      },
                                    },
                                    receivedAmount: {
                                      type: "number",
                                      attrs: {
                                        label: "Số tiền thực nhận",
                                        required: true,
                                      },
                                    },
                                  },
                                },
                              },
                            },
                          };
                          return attrs;
                        },
                        attrs: {},
                      },
                      buttons: {
                        save: {
                          content: {
                            text: "Xác nhận",
                          },
                          states: {},
                          on: {
                            async xClick({ self }) {
                              const dialog = self.context();
                              const btn = dialog.context();
                              const { item, dataTable } = btn.context();
                              const form = dialog.contentContainer.value;
                              const data = form.getData();
                              if (!data.receivedAmount) {
                                alert("Vui lòng nhập số tiền thực nhận.");
                                return;
                              }
                              self.loading.value = true;
                              const result = await dataTable.execute(
                                async () => {
                                  return await coreApiClient.call(
                                    "wholesaleOrders",
                                    "confirmSamplePayment",
                                    {
                                      id: item._id,
                                    },
                                    {
                                      paymentPartnerId: data.paymentPartnerId,
                                      paymentAccountId: data.paymentAccountId,
                                      receivedAmount: data.receivedAmount,
                                    }
                                  );
                                },
                                undefined,
                                {
                                  disableLoading: true,
                                  willRefresh: true,
                                }
                              );
                              self.loading.value = false;
                              if (result) {
                                dialog.hide();
                              }
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
              wholesaleConfirm: userManager.checkRole(["kt"]) && {
                ext: {
                  condition(_, item) {
                    return !item.wholesaleConfirmed;
                  },
                },
                attrs: {},
                content: {
                  icon: "mdi-stamper",
                },
                target: {
                  tooltip: {
                    content: {
                      text: "Kế toán xác nhận",
                    },
                  },
                  dialog: {
                    handlers: {
                      initialize() {
                        this.options.content.buttons.save.states.enabled = new DataContainer(false);
                      },
                    },
                    content: {
                      toolbar: {
                        title: "Kế toán xác nhận",
                        subTitle(dialog) {
                          const btn = dialog.context();
                          const { item } = btn.context();
                          return item.code;
                        },
                      },
                      content: {
                        type: "XForm",
                        makeAttrs(attrs, dialog) {
                          attrs.xModel = dialog.options.content.buttons.save.states.enabled;
                          attrs.xContext = dialog;
                          attrs.xData = new DataContainer({});
                          attrs.xOptions = {
                            content: {
                              sections: {
                                default: {
                                  fields: {
                                    files: {
                                      type: "file",
                                      attrs: {
                                        multiple: true,
                                        label: "Hóa đơn",
                                      },
                                    },
                                    exchangeRate: {
                                      type: "number",
                                      attrs: {
                                        label: "Tỷ giá",
                                        "prepend-icon": "mdi-currency-usd",
                                        suffix: `VNĐ / ${item2.currency}`,
                                      },
                                    },
                                  },
                                },
                              },
                            },
                          };
                          return attrs;
                        },
                        attrs: {},
                      },
                      buttons: {
                        save: {
                          content: {
                            text: "Xác nhận",
                          },
                          states: {},
                          on: {
                            async xClick({ self }) {
                              const dialog = self.context();
                              const btn = dialog.context();
                              const { item, dataTable } = btn.context();
                              const form = dialog.contentContainer.value;
                              const data = form.getData();
                              self.loading.value = true;
                              const result = await dataTable.execute(
                                async () => {
                                  return await coreApiClient.call(
                                    "wholesaleOrders",
                                    "wholesaleConfirm",
                                    {
                                      id: item._id,
                                      exchangeRate: data.exchangeRate,
                                    },
                                    data,
                                    true
                                  );
                                },
                                undefined,
                                {
                                  disableLoading: true,
                                  willRefresh: true,
                                }
                              );
                              self.loading.value = false;
                              if (result) {
                                dialog.hide();
                              }
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
              wholesaleBillImages: userManager.checkRole(["kt"]) && {
                ext: {
                  condition(_, item) {
                    return item.wholesaleBillImages && item.wholesaleBillImages.length > 0;
                  },
                },
                attrs: {},
                content: {
                  icon: "mdi-list-box-outline",
                },
                target: {
                  tooltip: {
                    content: {
                      text: "Bill xác nhận",
                    },
                  },
                  dialog: {
                    content: {
                      toolbar: {
                        title: "Bill xác nhận",
                        subTitle(dialog) {
                          const btn = dialog.context();
                          const { item } = btn.context();
                          return item.code;
                        },
                      },
                      content: {
                        type: WholesaleBillImagesVue,
                        makeAttrs(attrs, dialog) {
                          attrs.item = dialog.context().context().item;
                          return attrs;
                        },
                        attrs: {},
                      },
                    },
                  },
                },
              },
              resetShippingPayment: userManager.checkRole(["admin", "kt"]) && {
                ext: {
                  condition(_, item) {
                    return (item.shippingPaymentRecords || []).length > 0;
                  },
                },
                attrs: {},
                content: {
                  icon: "mdi-truck-remove",
                },
                on: {
                  async xClick({ self }) {
                    const { item, dataTable } = self.context();
                    if (!confirm("Thao tác này sẽ xóa lịch sử xác nhận thanh toán phí ship. Bạn có chắc chắn không?")) {
                      return;
                    }
                    self.loading.value = true;
                    await dataTable.execute(async () => coreApiClient.call("wholesaleOrders", "resetShippingPayment", { id: item._id }), undefined, { disableLoading: true, willRefresh: true });
                    self.loading.value = false;
                  },
                },
                target: {
                  tooltip: {
                    content: {
                      text: "Reset thanh toán phí ship",
                    },
                  },
                },
              },
              resetPayment: userManager.checkRole(["admin", "kt"]) && {
                attrs: {},
                content: {
                  icon: "mdi-restart",
                },
                on: {
                  async xClick({ self }) {
                    const { item, dataTable } = self.context();
                    if (!confirm("Thao tác này sẽ xóa toàn bộ lịch sử thanh toán, đơn hàng liên quan và giao dịch ví liên quan. Bạn có chắc chắn không?")) {
                      return;
                    }
                    self.loading.value = true;
                    await dataTable.execute(async () => coreApiClient.call("wholesaleOrders", "resetPayment", { id: item._id }), undefined, { disableLoading: true, willRefresh: true });
                    self.loading.value = false;
                  },
                },
                target: {
                  tooltip: {
                    content: {
                      text: "Reset thanh toán",
                    },
                  },
                },
              },
              exportDeliveryNote: {
                attrs: {},
                content: {
                  icon: "mdi-download",
                },
                on: {
                  xClick({ self }) {
                    const { item } = self.context();
                    coreApiClient.download("wholesaleOrders", `${item._id}/deliveryNote`);
                  },
                },
                target: {
                  tooltip: {
                    content: {
                      text: `Export Delivery Note`,
                    },
                  },
                },
              },
            },
          },
          findAllOptionsFilter(options) {
            options.filters.push({
              key: "marketId",
              operator: "equal_to",
              value: item._id,
            });
            return options;
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call("wholesaleOrders", "findAll", options);
              return [items, count];
            },
            async insert(item) {
              item.marketId = item2._id;
              return await coreApiClient.call("wholesaleOrders", "create", undefined, item);
            },
            async update(item) {
              return await coreApiClient.call(
                "wholesaleOrders",
                "update",
                {
                  id: item._id,
                },
                {
                  data: item,
                }
              );
            },
            async delete(item) {
              return await coreApiClient.call("wholesaleOrders", "delete", {
                id: item._id,
              });
            },
          },
          default: {
            defaultInputs: {
              code: {
                attrs: {
                  label: "Mã đơn hàng",
                  required: true,
                },
              },
              dataSource: {
                type: "select",
                attrs: {
                  label: "Nguồn data",
                  items: makeSelectOptions(orderDataSources),
                },
              },
              dataSourceId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Nguồn data (quản lý)",
                  "item-value": "_id",
                  "item-text": "name",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("dataSources", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
              },
              customerId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Khách hàng",
                  "item-value": "_id",
                  "item-text": "code",
                  "item-disabled": "_",
                  required: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("wholesaleCustomers", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
              },
              time: {
                type: "XDateTimePicker",
                attrs: {
                  label: "Order Date",
                  required: true,
                },
              },
              items: {
                type: "XArrayInput",
                attrs: {
                  label: "",
                  xOptions: {
                    content: {
                      template: {
                        formOptions: {
                          content: {
                            colLength: 2,
                          },
                        },
                      },
                      itemProperties: {
                        productId: {
                          type: "XAutocomplete",
                          attrs: {
                            label: "Sản phẩm",
                            "item-value": "_id",
                            "item-text": "sku",
                            "item-disabled": "_",
                            required: true,
                            xOptions: {
                              content: {
                                async itemsSuggestor(search, value, limit) {
                                  const { items } = await coreApiClient.call("products", "findAll", {
                                    payload: JSON.stringify({
                                      limit,
                                      search,
                                      filters: [
                                        {
                                          key: "_id",
                                          operator: "equal_to",
                                          value,
                                        },
                                        {
                                          key: "countryId",
                                          operator: "equal_to",
                                          value: item.countryId,
                                        },
                                      ],
                                    }),
                                  });
                                  return items;
                                },
                              },
                            },
                          },
                        },
                        type: {
                          type: "select",
                          attrs: {
                            text: "Loại sản phẩm",
                            items: makeSelectOptions(productComboProductItemRoles),
                            required: true,
                          },
                        },
                        count: {
                          type: ganiAsiaTenantCodes.includes(userManager.tenantCode()) ? "number" : "number", // float for all tenants
                          attrs: {
                            label: "Số lượng",
                            required: true,
                          },
                        },
                        overriddenPrice: {
                          type: "number",
                          attrs: {
                            label: "Giá",
                          },
                          ext: {
                            condition() {
                              return ganiAsiaTenantCodes.includes(userManager.tenantCode());
                            },
                          },
                        },
                        discountPercentage: {
                          type: "number",
                          attrs: {
                            label: "Discount (%)",
                          },
                          ext: {
                            condition(form) {
                              return form.getData().discountPercentageFixed;
                            },
                          },
                        },
                        discountPercentageFixed: {
                          type: "boolean",
                          attrs: {
                            label: "Fix Discount",
                          },
                        },
                        description: {
                          attrs: {
                            label: "Mô tả",
                          },
                        },
                      },
                      rules: {
                        custom: [
                          async (value) => {
                            return value && value.length;
                          },
                        ],
                      },
                    },
                  },
                },
              },
              cashback: {
                type: "number",
              },
              shippingFee: {
                type: "number",
                attrs: {
                  label: "Phí Ship",
                },
              },
              sampleFee: {
                type: "number",
                attrs: {
                  label: "Phí sample",
                },
              },
              warehouseId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Kho",
                  "item-value": "_id",
                  "item-text": "name",
                  "item-disabled": "_",
                  required: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("warehouses", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                              {
                                key: "countryId",
                                operator: "equal_to",
                                value: item.countryId,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
              },
            },
            insertForm: userManager.checkRole(["admin", "kt", "vd", "vdl"]) && {
              content: {
                fieldNames: ["code", "dataSource", "dataSourceId", "customerId", "time", "cashback", "shippingFee", "sampleFee", "warehouseId", "items"],
              },
            },
            editForm: userManager.checkRole(["admin", "kt", "vd", "vdl"]) && {
              content: {
                fieldNames: ["code", "dataSource", "dataSourceId", "customerId", "time", "cashback", "shippingFee", "sampleFee", "warehouseId", "items"],
              },
            },
            delete: userManager.checkRole(["admin"]) && {
              confirmDisplayField: "code",
            },
          },
        },
      };
    },
  },
  async created() {
    this.item = await coreApiClient.call("markets", "findById", {
      id: this.$route.params.marketId,
    });
    this.tableOptions = this.makeTableOptions(this.item);
  },
});
